export enum SubscriptionStatus {
  BASIC = 'basic',
}
